module.exports = __webpack_public_path__ + "static/media/vip-membership.265609a1.png";